/** A list that failed to load says so in place, with Retry — the tour-wide list and the
 *  date-specific grid alike. One 36px line (a row's height), so the block does not jump. */
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Button, Typography } from '@mui/material';

export function LoadError({ what, onRetry }: { what: string; onRetry: () => void }) {
  return (
    <Typography
      variant="body2"
      color="error"
      role="alert"
      sx={{ display: 'flex', gap: 0.5, alignItems: 'center', minHeight: 36 }}
      data-selfreg-error
    >
      <ErrorOutlineIcon aria-hidden sx={{ fontSize: 16 }} />
      Couldn’t load {what} —
      <Button size="small" color="inherit" onClick={onRetry} sx={{ minWidth: 0, py: 0 }}>
        Retry
      </Button>
    </Typography>
  );
}
